import { makeStyles, Theme } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()((theme: Theme) => {
  return {
    container: {
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(11)
      },
      padding: theme.spacing(5, 4)
    },
    visual: {
      marginBottom: theme.spacing(5)
    },
    languageList: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(2),
      width: '100%',
      maxWidth: 320
    },
    languageButton: {
      width: '100%',
      minHeight: 48
    }
  }
})

export default useStyles
